import Swal from 'sweetalert2';

import { colors } from '@globalStyles';

const ErrorToast = Swal.mixin({
  title: 'Something went wrong!',
  text: 'Unknown error',
  icon: 'error',
  confirmButtonColor: colors.evetro_green
});

const error = (swalOptions = {}) => ErrorToast.fire({ ...swalOptions });

export default error;
